import { DecimalPipe, NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { isEqual } from 'lodash-es';

import { ProductContextDirective } from 'ish-core/directives/product-context.directive';
import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { LineItemUpdate } from 'ish-core/models/line-item-update/line-item-update.model';
import { LineItemView } from 'ish-core/models/line-item/line-item.model';
import { OrderLineItem } from 'ish-core/models/order/order.model';
import { PricePipe } from 'ish-core/models/price/price.pipe';
import { ServerSettingPipe } from 'ish-core/pipes/server-setting.pipe';
import { LineItemEditComponent } from 'ish-shared/components/line-item/line-item-edit/line-item-edit.component';
import { LineItemWarrantyComponent } from 'ish-shared/components/line-item/line-item-warranty/line-item-warranty.component';
import { ProductImageComponent } from 'ish-shared/components/product/product-image/product-image.component';
import { ProductInventoryComponent } from 'ish-shared/components/product/product-inventory/product-inventory.component';
import { ProductNameComponent } from 'ish-shared/components/product/product-name/product-name.component';
import { ProductQuantityComponent } from 'ish-shared/components/product/product-quantity/product-quantity.component';

@Component({
  selector: 'custom-checkout-line-item-element',
  templateUrl: './custom-checkout-line-item-element.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    FaIconComponent,
    ProductImageComponent,
    ProductNameComponent,
    NgSwitch,
    NgSwitchCase,
    ProductInventoryComponent,
    NgSwitchDefault,
    LineItemEditComponent,
    ProductContextDirective,
    NgFor,
    NgbPopover,
    ProductQuantityComponent,
    NgClass,
    LineItemWarrantyComponent,
    DecimalPipe,
    PricePipe,
    ServerSettingPipe,
    TranslateModule,
  ],
})
export class CustomCheckoutLineItemElementComponent implements OnInit {
  private context = inject(ProductContextFacade);
  private checkoutFacade = inject(CheckoutFacade);

  readonly pli = input<Partial<LineItemView & OrderLineItem>>(undefined);
  readonly editable = input(true);
  readonly lineItemViewType = input<'simple' | 'availability'>(undefined);

  isOnePageCheckout = true;

  ngOnInit() {
    this.context.hold(this.context.validDebouncedQuantityUpdate$(), quantity => {
      this.checkoutFacade.updateBasketItem({ itemId: this.pli().id, quantity });
    });
  }

  get oldPrice() {
    const pli = this.pli();
    return isEqual(pli.singleBasePrice, pli.undiscountedSingleBasePrice) ? undefined : pli.undiscountedSingleBasePrice;
  }

  onUpdateItem(update: LineItemUpdate) {
    this.checkoutFacade.updateBasketItem(update);
  }

  onDeleteItem(itemId: string) {
    this.checkoutFacade.deleteBasketItem(itemId);
  }
}
